export default __webpack_public_path__ + "48b9c38e3d9863db970bf3fb7572b0d7.webm";